import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuthService,useContextService } from '../../services';
import { ApiUrl, SessionKey } from "../../utils/app-config";

function MIAuthCallback() {
  let [searchParams] = useSearchParams();
  const { putContextUser} = useContextService();
    const {getToken} = useAuthService(); 

  useEffect(() => {
    var code = searchParams.get("code");
    var state = searchParams.get("state");
    const storedSingpassAuth = localStorage.getItem("singpassAuth");
    const singpassAuth = storedSingpassAuth ? JSON.parse(storedSingpassAuth) : {};
    var tokenRequest = {
      code: code,
      state: state,
      cacheId: singpassAuth.cacheId
    }
    const fetchData = async () => {
      let token = await getToken(tokenRequest, ApiUrl.MyInfoToken);
      if(token.user){
        await putContextUser(token.user);
        localStorage.setItem(SessionKey.AuthToken, token.jwt);
        window.location.href = '/eservices/';
      }
    }
    fetchData();
  }, [])


  return (
    <div>
      <div>Redirecting.........</div>
    </div>
  );
}

export default MIAuthCallback;
